export const sliderItem = [
  {
    id: 1,
    img: "viewTent.jpg",
    title: "ТУРИСТИЧЕСКОЕ СНАРЯЖЕНИЕ",
    descripshion: "ПРОДАЖА И АРЕНДА",
  },
  {
    id: 2,
    img: "setForTwo.jpg",
    title: "НАБОР ДЛЯ ДВОИХ",
    descripshion: "45 GEL",
  },
  {
    id: 3,
    img: "certificate.jpg",
    title: "ПОДАРОЧНЫЙ СЕРТИФИКАТ",
    descripshion: "ЛЮБОГО НОМИНАЛА",
  },
];
